:host {
  display: block;
}

.spw-accordion-title {
  padding: var(--spw-spacings-spacing-lg);
  font-weight: 700;
  transition: all 0.3s;
  color: var(--spw-color-themes-grey-grey-900);

  &:hover {
    color: var(--spw-ds-primary);
    :host(.--collapsed) & {
      background: var(--spw-color-themes-grey-grey-100);
    }
  }
}

:host-context(.spw-accordion-item:hover) > .spw-accordion-title {
  color: var(--spw-ds-primary);
}

.spw-accordion-title__content {
  position: relative;
  padding-right: var(--spw-spacings-spacing-3-xl);
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 16px;
  }
}

.spw-accordion-title__trigger {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%) rotate(180deg);
  transition: all 0.3s;

  :host(.--collapsed) & {
    transform: translateY(-50%) rotate(0deg);
  }
}
